import { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  open: boolean
  onClose: () => void
}

export function ChipSearchModal({ open, onClose }: Props) {
  const { t } = useTranslation()
  const [q, setQ] = useState('')
  const [resultNote, setResultNote] = useState<string | null>(null)

  if (!open) return null

  return (
    <div className="modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="chip-search-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="chip-search-title">{t('forms.chipSearchTitle')}</h2>
        <form
          className="form-grid"
          onSubmit={async (e) => {
            e.preventDefault()
            try {
              const res = await fetch(`/api/search/chip?q=${encodeURIComponent(q)}`)
              if (!res.ok) {
                setResultNote(t('forms.noResults'))
                return
              }
              const data = (await res.json()) as {
                animals: unknown[]
                sightings: unknown[]
              }
              const total = (data.animals?.length ?? 0) + (data.sightings?.length ?? 0)
              setResultNote(total ? `${total} hit(s)` : t('forms.noResults'))
            } catch {
              setResultNote(t('status.error'))
            }
          }}
        >
          <div className="field">
            <label htmlFor="chip-q">{t('fields.chip')}</label>
            <input
              id="chip-q"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder={t('forms.chipPlaceholder')}
              autoFocus
            />
          </div>
          {resultNote && <p className="empty-state">{resultNote}</p>}
          <div className="form-actions">
            <button type="button" className="btn" onClick={onClose}>
              {t('actions.cancel')}
            </button>
            <button type="submit" className="btn btn-primary">
              {t('actions.search')}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
